export default __webpack_public_path__ + "static/media/contact-banner.240beb74.png";